var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "mmp-nightmode-btn",
      class: { "mmp-nightmode-btn--active": _vm.active },
      attrs: {
        type: "button",
        title: _vm.active ? "Switch to day mode" : "Switch to night mode",
      },
      on: {
        click: function ($event) {
          return _vm.$emit("toggle")
        },
      },
    },
    [
      !_vm.active
        ? _c(
            "svg",
            {
              staticClass: "mmp-nightmode-icon",
              attrs: {
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _c(
            "svg",
            {
              staticClass: "mmp-nightmode-icon",
              attrs: {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "12",
                  cy: "12",
                  r: "4",
                  fill: "currentColor",
                  stroke: "none",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41",
                },
              }),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }